<template>
  <v-container fluid>
    <PageHeaderSlot />

    <v-card>
      <v-card-text class="px-2">
        <v-row class="ma-0">
          <v-col cols="12" v-if="this.gEnableAutoGenCourse">
            <v-checkbox
              v-model="formData.disable_grade"
              :label="$t('disableGrade')"
              color="primary"
              hide-details
              class="mt-0 upgrade-checkbox"
              @change="$store.dispatch('setDataIsUpdated', true)"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" v-if="!formData.disable_grade">
            <v-checkbox
              v-model="formData.upgrade_setting"
              :label="$t('enableUpgrade')"
              color="primary"
              hide-details
              class="mt-0 upgrade-checkbox"
              @change="$store.dispatch('setDataIsUpdated', true)"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <FormButton class="mt-4 mb-8" :disabled="tableLoading" @click="save()" />

    <Datatable
      v-if="!formData.disable_grade"
      tableName="group"
      :isLoading="tableLoading"
      :tableHeaders="tableHeaders"
      :tableData.sync="tableData"
      @delete-clicked="handleDelete($event)"
      @edit-clicked="handleAddGrade($event)"
      @ondrag="handleGradeSortChanged($event)"
      dispatchUpdateOnChange
      disablePagination
      :enableDrag="false"
    >
      <template slot="append-toolbar-left">
        <FormButton text="add" class="ml-4 my-2" @click="handleAddGrade()" isAdd />
      </template>
      <template v-slot:[`item.actionSort`]="{ item, index }">
        <div class="d-flex align-center">
          <v-btn
            v-if="index > 0"
            outlined
            color="primary"
            icon
            small
            class="btn-sort-up mr-2"
            @click.prevent="handleGradeUp(index)"
          >
            <v-icon class="fi fi-rr-sort-down" small></v-icon>
          </v-btn>
          <v-btn
            outlined
            color="primary"
            icon
            small
            v-if="index < tableData.length - 1"
            @click.prevent="handleGradeDown(index)"
          >
            <v-icon class="fi fi-rr-sort-down" small></v-icon>
          </v-btn>
        </div>
      </template>
    </Datatable>

    <!-- Modal: 新增組別 -->
    <FormDialog ref="gradeFormDialog" formRef="gradeForm" title="group" :maxWidth="500">
      <v-row class="ma-0">
        <v-col cols="12">
          <FormInput label="groupName" placeholder="groupName" :fieldValue.sync="addGradeData.name" required />
        </v-col>
        <v-col cols="12" v-if="addGradeData.is_new">
          <v-checkbox
            v-model="addGradeData.auto_course"
            :label="$t('autoCreateGradeCourse')"
            color="primary"
            hide-details
            class="mt-0 upgrade-checkbox"
          ></v-checkbox>
        </v-col>
      </v-row>
    </FormDialog>
  </v-container>
</template>

<script>
import Datatable from '@/components/Datatable.vue'
import FormInput from '@/components/formField/FormInput.vue'
import FormDialog from '@/components/FormDialog.vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  name: 'GradeSetting',
  inject: ['getConfirmDialogRef'],
  components: {
    Datatable,
    FormInput,
    FormDialog,
    ConfirmDialog,
  },
  computed: {
    tableHeaders() {
      const vm = this
      let headers = [
        { value: 'name', text: vm.$t('groupName') },
        { value: 'minActionEditAndDelete', text: '', align: 'end' },
      ]
      if (this.tableData.length > 1) {
        headers.unshift({ value: 'actionSort', text: '', width: 100 })
      }
      return headers
    },
  },
  data: vm => ({
    tableLoading: false,
    tableData: [],

    formData: {
      upgrade_setting: false,
      disable_grade: false,
    },

    addGradeData: {
      name: '',
      auto_course: true,
      is_new: false,
    },
  }),
  methods: {
    async getSetting() {
      try {
        const data = await this.$Fetcher.GetSetting()
        if (this.$validate.DataValid(data.upgrade_setting)) {
          this.formData.upgrade_setting = data.upgrade_setting
        }
        if (this.$validate.DataValid(data.need_grade)) {
          this.formData.disable_grade = !data.need_grade
        }

        if (!this.gEnableAutoGenCourse) {
          this.formData.disable_grade = false
        }
      } catch (err) {
        this.$common.error(err)
      }
    },

    async getGrades() {
      this.tableLoading = true
      try {
        const data = await this.$Fetcher.GetGrades()
        this.tableData = data
      } catch (err) {
        this.$common.error(err)
        this.tableData = []
      } finally {
        this.tableLoading = false
      }
    },

    // -- (儲存)
    async save() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      this.$store.dispatch('setLoading', true)
      try {
        const payload = {
          need_grade: !this.formData.disable_grade,
          upgrade_setting: this.formData.upgrade_setting,
        }
        await this.$Fetcher.UpdateSetting(payload)
        this.$store.dispatch('toggleSnack', {
          message: 'message.saveSuccess',
          type: 'success',
        })
        this.$store.dispatch('setDataIsUpdated', false)
      } catch (err) {
        this.showAlert({
          title: 'message.saveFail',
          message: err,
          isError: true,
        })
      } finally {
        this.$store.dispatch('setLoading', false)
      }
    },

    // -- 新增組別
    async handleAddGrade(id = null, newOpen = true) {
      // reset form when open
      if (newOpen) {
        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }
        this.addGradeData.name = ''
        if (!this.$validate.DataValid(id)) {
          this.addGradeData.is_new = true
          await this.$refs.gradeFormDialog.resetForm()
        } else {
          const found = this.tableData.find(el => el.id === id)
          if (found) {
            this.addGradeData.name = found.name
          }
          this.addGradeData.is_new = false
        }
        this.addGradeData.auto_course = true
      } else {
        this.$refs.gradeFormDialog.setLoading(false)
      }

      // handle form submit
      const confirm = await this.$refs.gradeFormDialog.show()
      if (confirm) {
        const found = this.tableData.find(el => el.name.trim() === this.addGradeData.name.trim())
        if (found && found.id !== id) {
          this.$store.dispatch('toggleSnack', { type: 'error', message: 'message.gradeExist' })
          this.handleAddGrade(id, false)
          return
        }

        try {
          const payload = {
            name: this.addGradeData.name.trim(),
          }
          if (this.$validate.DataValid(id)) {
            await this.$Fetcher.UpdateGrade(id, payload)
          } else {
            const data = await this.$Fetcher.NewGrade(payload)
            if (this.addGradeData.auto_course) {
              await this._createCourses(data.grade_key)
            }
          }
          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
          })
          this.$store.dispatch('setDataIsUpdated', false)
          this.$refs.gradeFormDialog.hide()
          this.tableLoading = true
          setTimeout(() => {
            this.getGrades()
          }, 500)
        } catch (err) {
          this.showAlert({
            title: 'message.saveFail',
            message: err,
            isError: true,
          })
          this.handleAddGrade(id, false)
        }
      }
    },
    async _createCourses(grade) {
      try {
        const { data } = await this.$Fetcher.GetCourseCategories()
        await this._createCourse(grade, data)
      } catch {}
    },
    async _createCourse(grade, categories, count = 0) {
      if (count < categories.length) {
        try {
          await this.$Fetcher.NewCourse({
            grade: grade,
            schools: categories[count]['schools'],
            category_id: categories[count]['id'],
          })
          count += 1
          await this._createCourse(grade, categories, count)
        } catch (err) {
          this.$common.error(err)
        }
      }
    },

    // -- (刪除組別)
    async handleDelete(id) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirmRef = this.getConfirmDialogRef()
      const confirm = await confirmRef.show({
        title: 'message.confirmToDeleteItem',
        message: 'message.deleteGradeWithCourses',
      })
      if (confirm) {
        this.$store.dispatch('setLoading', true)
        try {
          await this.$Fetcher.DeleteGrade(id)

          // delete courses
          const gradeData = this.tableData.find(el => el.id === id)
          await this._deleteCourses(gradeData.grade_key)

          this.$store.dispatch('toggleSnack', {
            message: 'message.deleteSuccess',
            type: 'success',
          })
          this.getGrades()
        } catch (err) {
          this.showAlert({
            title: 'message.deleteFail',
            message: err,
            isError: true,
          })
        }
        this.$store.dispatch('setLoading', false)
      }
    },
    async _deleteCourses(grade) {
      try {
        const { data } = await this.$Fetcher.GetCourses({
          filter_item: [{ key: 'grade', value: grade }],
        })
        const courseIds = data.map(el => el.id)
        await this._deleteCourse(courseIds)
      } catch {}
    },
    async _deleteCourse(courses, count = 0) {
      if (count < courses.length) {
        try {
          await this.$Fetcher.DeleteCourse(courses[count])
          count += 1
          await this._deleteCourse(courses, count)
        } catch (err) {
          this.$common.error(err)
        }
      }
    },

    // -- Change sorting
    handleGradeUp(index) {
      if (this.$store.getters.isLoading || this.tableLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      if (index <= 0) return
      this._submitGradeSort(this.tableData[index].sort_order, this.tableData[index - 1].sort_order)
    },
    handleGradeDown(index) {
      if (this.$store.getters.isLoading || this.tableLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      if (index >= this.tableData.length - 1) return
      this._submitGradeSort(this.tableData[index].sort_order, this.tableData[index + 1].sort_order)
    },
    async _submitGradeSort(from, to) {
      this.$store.dispatch('setLoading', true)
      this.tableLoading = true

      try {
        await this.$Fetcher.UpdateGradeSorting(from, to)
      } catch (err) {
        this.showAlert({
          title: 'message.saveFail',
          message: err,
          isError: true,
        })
      } finally {
        this.$store.dispatch('setLoading', false)
        this.tableLoading = false
        this.getGrades()
      }
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: GradeSetting')
      await this.getSetting()
      this.$store.dispatch('toggleLoadingPage', false)
      this.getGrades()
    },
  },

  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.tableLoading = true
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else if (this.$store.getters.dataIsUpdated) {
      this.$store.dispatch('showLeaveAlert', { toLink: { name: to.name } })
      next(false)
    } else {
      this.$XHR.abort()
      next()
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep.upgrade-checkbox {
  & label {
    color: var(--v-colorBlack-base);
    font-weight: 500;
  }
}

.btn-sort-up {
  transform: rotate(180deg);
}
</style>
